<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800 text-white min-h-screen py-10">
    <h1 class="text-3xl font-semibold">Statystyki</h1>
    <p class="mt-2 text-lg text-gray-400">
      Ta strona będzie zawierać różne statystyki dotyczące danych w systemie.
    </p>

    <div class="mt-10">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <!-- Przykładowa karta statystyk -->
        <div class="bg-gray-700 p-6 rounded-lg">
          <h2 class="text-xl font-bold">Całkowita liczba lokali</h2>
          <p class="mt-4 text-4xl font-extrabold text-indigo-400">1,234</p>
          <p class="mt-2 text-sm text-gray-400">Dane na dzień dzisiejszy</p>
        </div>

        <div class="bg-gray-700 p-6 rounded-lg">
          <h2 class="text-xl font-bold">Lokale z CID</h2>
          <p class="mt-4 text-4xl font-extrabold text-teal-400">567</p>
          <p class="mt-2 text-sm text-gray-400">Gotowe do eksportu</p>
        </div>

        <div class="bg-gray-700 p-6 rounded-lg">
          <h2 class="text-xl font-bold">Najczęstszy influencer</h2>
          <p class="mt-4 text-4xl font-extrabold text-orange-400">Książulo</p>
          <p class="mt-2 text-sm text-gray-400">Na podstawie liczby recenzji</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// W przyszłości tutaj można będzie dodać logikę do pobierania i przetwarzania danych
</script> 
